var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#222",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16 17.399-7 7c-.2.2-.434.3-.7.3a.96.96 0 0 1-.7-.3.96.96 0 0 1-.3-.7c0-.267.1-.5.3-.7l7-7-7-7a.96.96 0 0 1-.3-.7c0-.267.1-.5.3-.7.2-.2.433-.3.7-.3.266 0 .5.1.7.3l7 7 7-7c.2-.2.433-.3.7-.3.267 0 .5.1.7.3.2.2.3.433.3.7 0 .266-.1.5-.3.7l-7 7 7 7c.2.2.3.433.3.7 0 .266-.1.5-.3.7-.2.2-.433.3-.7.3a.96.96 0 0 1-.7-.3l-7-7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16 17.399-7 7c-.2.2-.434.3-.7.3a.96.96 0 0 1-.7-.3.96.96 0 0 1-.3-.7c0-.267.1-.5.3-.7l7-7-7-7a.96.96 0 0 1-.3-.7c0-.267.1-.5.3-.7.2-.2.433-.3.7-.3.266 0 .5.1.7.3l7 7 7-7c.2-.2.433-.3.7-.3.267 0 .5.1.7.3.2.2.3.433.3.7 0 .266-.1.5-.3.7l-7 7 7 7c.2.2.3.433.3.7 0 .266-.1.5-.3.7-.2.2-.433.3-.7.3a.96.96 0 0 1-.7-.3l-7-7Z",
    fillOpacity: 0.2
  })));
};
export default SvgClose;